<template>
  <div
    class="strain"
    v-loading.lock="fullscreenLoading"
    element-loading-text="数据上传中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="header-breadcrumb">
      <p>毒株数据</p>
      <div class="header-utils">
        <el-tooltip
          class="item add"
          effect="dark"
          content="新建"
          placement="top"
        >
          <svg
            t="1646905027206"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5121"
            width="16"
            height="16"
            @click="openModify('new')"
          >
            <path
              d="M512 958.016611c-119.648434 0-232.1288-46.367961-316.736783-130.559656-84.640667-84.255342-131.263217-196.255772-131.263217-315.455235 0-119.168499 46.624271-231.199892 131.232254-315.424271 84.607983-84.191695 197.088348-130.559656 316.736783-130.559656s232.1288 46.367961 316.704099 130.559656c84.67163 84.224378 131.263217 196.255772 131.263217 315.391587 0.032684 119.199462-46.591587 231.232576-131.263217 315.455235C744.1288 911.615966 631.648434 958.016611 512 958.016611zM512 129.983389c-102.623626 0-199.071738 39.743475-271.583282 111.936783-72.480581 72.12794-112.416718 168.063432-112.416718 270.079828s39.903454 197.951888 112.384034 270.047144c72.511544 72.191587 168.959656 111.936783 271.583282 111.936783 102.592662 0 199.071738-39.743475 271.583282-111.936783 72.480581-72.160624 112.416718-168.063432 112.384034-270.079828 0-102.016396-39.903454-197.919204-112.384034-270.016181C711.071738 169.759548 614.592662 129.983389 512 129.983389z"
              p-id="5122"
              fill="#999999"
            ></path>
            <path
              d="M736.00086 480.00086 544.00086 480.00086 544.00086 288.00086c0-17.664722-14.336138-32.00086-32.00086-32.00086s-32.00086 14.336138-32.00086 32.00086l0 192L288.00086 480.00086c-17.664722 0-32.00086 14.336138-32.00086 32.00086s14.336138 32.00086 32.00086 32.00086l192 0 0 192c0 17.695686 14.336138 32.00086 32.00086 32.00086s32.00086-14.303454 32.00086-32.00086L544.00258 544.00086l192 0c17.695686 0 32.00086-14.336138 32.00086-32.00086S753.696546 480.00086 736.00086 480.00086z"
              p-id="5123"
              fill="#999999"
            ></path>
          </svg>
        </el-tooltip>
        <div class="dropdown">
          <el-dropdown placement="bottom">
            <span class="el-dropdown-link">
              <svg
                t="1646904841042"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3880"
                width="16"
                height="16"
                style="cursor: pointer"
              >
                <path
                  d="M42.164706 999.905882V18.070588H572.235294c6.023529 0 6.023529 0 6.02353 6.02353L873.411765 319.247059v90.352941h-90.352941v-42.164706c0-6.023529-6.023529-18.070588-6.02353-24.094118L566.211765 132.517647c-18.070588-12.047059-36.141176-18.070588-54.211765-18.070588H192.752941c-30.117647 0-60.235294 24.094118-60.235294 60.235294v686.682353c0 30.117647 24.094118 60.235294 60.235294 60.235294h686.682353v90.352941H42.164706z"
                  fill="#999999"
                  p-id="3881"
                ></path>
                <path
                  d="M680.658824 807.152941v-72.282353h295.152941V584.282353h-295.152941V512L457.788235 662.588235l222.870589 144.564706zM536.094118 277.082353H222.870588c-18.070588 0-30.117647-12.047059-30.117647-30.117647v-24.094118c0-18.070588 12.047059-30.117647 30.117647-30.117647h313.22353c18.070588 0 30.117647 12.047059 30.117647 30.117647v24.094118c0 18.070588-12.047059 30.117647-30.117647 30.117647zM445.741176 433.694118H216.847059c-12.047059 0-24.094118-12.047059-24.094118-24.094118v-36.141176c0-12.047059 12.047059-24.094118 24.094118-24.094118h228.894117c12.047059 0 24.094118 12.047059 24.094118 24.094118v36.141176c0 12.047059-12.047059 24.094118-24.094118 24.094118z"
                  fill="#999999"
                  p-id="3882"
                ></path>
              </svg>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <p style="font-size: 16px;">
                  <el-upload
                    class="sequence-upload"
                    style="display:inline-block"
                    action="/"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="getExcelFile"
                    accept=".xlsx"
                  >
                    <span
                      onMouseOver="this.style.color='#05579e'"
                      onMouseOut="this.style.color='#666'"
                      >导入excel</span
                    >
                  </el-upload>
                  <span
                    style="font-size: 12px;"
                    onMouseOver="this.style.color='#05579e'"
                    onMouseOut="this.style.color='#666'"
                    @click="downloadWebData"
                    >(下载模版)</span
                  >
                </p>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-upload
                  class="sequence-upload"
                  action="/"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="fileHandleMoreChange"
                  accept=".genomic.fna.gz,.cds.fna.tar.gz,.ffn.tar.gz,.protein.faa.gz,.faa.gz,.COG_KOG.zip,.GO.zip,.KEGG.zip,.NR.zip,.NT.zip,.swissprot.zip"
                  multiple
                >
                  <p
                    style="font-size: 16px;"
                    onMouseOver="this.style.color='#05579e'"
                    onMouseOut="this.style.color='#666'"
                  >
                    导入序列
                  </p>
                </el-upload>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="导入序列"
          placement="top"
        >
          <el-upload
            action="/"
            :auto-upload="false"
            :on-change="fileHandleMoreChange"
            :show-file-list="false"
            multiple
            accept=".genomic.fna.gz,.cds.fna.tar.gz,.ffn.tar.gz,.protein.faa.gz,.faa.gz,.COG_KOG.zip,.GO.zip,.KEGG.zip,.NR.zip,.NT.zip,.swissprot.zip"
          >
            <svg
              t="1646904841042"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3880"
              width="16"
              height="16"
            >
              <path
                d="M42.164706 999.905882V18.070588H572.235294c6.023529 0 6.023529 0 6.02353 6.02353L873.411765 319.247059v90.352941h-90.352941v-42.164706c0-6.023529-6.023529-18.070588-6.02353-24.094118L566.211765 132.517647c-18.070588-12.047059-36.141176-18.070588-54.211765-18.070588H192.752941c-30.117647 0-60.235294 24.094118-60.235294 60.235294v686.682353c0 30.117647 24.094118 60.235294 60.235294 60.235294h686.682353v90.352941H42.164706z"
                fill="#999999"
                p-id="3881"
              ></path>
              <path
                d="M680.658824 807.152941v-72.282353h295.152941V584.282353h-295.152941V512L457.788235 662.588235l222.870589 144.564706zM536.094118 277.082353H222.870588c-18.070588 0-30.117647-12.047059-30.117647-30.117647v-24.094118c0-18.070588 12.047059-30.117647 30.117647-30.117647h313.22353c18.070588 0 30.117647 12.047059 30.117647 30.117647v24.094118c0 18.070588-12.047059 30.117647-30.117647 30.117647zM445.741176 433.694118H216.847059c-12.047059 0-24.094118-12.047059-24.094118-24.094118v-36.141176c0-12.047059 12.047059-24.094118 24.094118-24.094118h228.894117c12.047059 0 24.094118 12.047059 24.094118 24.094118v36.141176c0 12.047059-12.047059 24.094118-24.094118 24.094118z"
                fill="#999999"
                p-id="3882"
              ></path>
            </svg>
          </el-upload>
        </el-tooltip> -->
      </div>
    </div>
    <div class="middle-box">
      <div class="search-box">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          ref="ruleForm"
        >
          <el-form-item label="物种" prop="user">
            <el-input
              v-model="formInline.user"
              placeholder="请输入"
              class="user-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="序列编号" prop="code">
            <el-input
              v-model="formInline.code"
              placeholder="请输入"
              class="user-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-form-item prop="startDate">
                <el-date-picker
                  v-model="formInline.startDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="”yyyy-MM-dd”"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="更新时间">
            <el-col :span="11">
              <el-form-item prop="undateDate">
                <el-date-picker
                  v-model="formInline.undateDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="”yyyy-MM-dd”"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">重置条件</el-button>
            <el-button type="primary" @click="getData">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :class="{ table: tableData.length !== 0 }"
        >
          <el-table-column type="selection" width="55" fixed="left">
          </el-table-column>
          <el-table-column
            prop="strainName"
            label="Species"
            width="310"
            fixed="left"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <i>{{ scope.row.strainName }}</i>
            </template>
          </el-table-column>
          <el-table-column prop="serialCode" label="Database ID" width="150">
          </el-table-column>
          <el-table-column
            prop="genomeSequence"
            label="Genomic"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.genomeSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="gdsSequence"
            label="CDS"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.gdsSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="proteinSequence"
            label="Protein"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.proteinSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="cogKogSequence"
            label="COG/KOG"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.cogKogSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="goSequence"
            label="GO"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.goSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="keggSequence"
            label="KEGG"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.keggSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="nrSequence"
            label="NR"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.nrSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="ntSequence"
            label="NT"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.ntSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="swSequence"
            label="Swiss-Prot"
            width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">{{
              row.swSequence || '-'
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="Create time"
            width="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="Update time"
            width="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="" fixed="right">
            <template slot-scope="scope">
              <div class="disappear appear">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                >
                  <svg
                    @click="openModify(scope.$index)"
                    t="1648024164242"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4326"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M512 25.6C243.2 25.6 25.6 243.2 25.6 512c0 268.8 217.6 486.4 486.4 486.4 268.8 0 486.4-217.6 486.4-486.4C998.4 243.2 780.8 25.6 512 25.6z m76.8 524.8l-128 128-6.4 6.4c-6.4 6.4-12.8 6.4-19.2 6.4l-38.4 12.8-76.8 38.4c-19.2 6.4-44.8-19.2-38.4-38.4l25.6-64 19.2-51.2c0-6.4 6.4-12.8 12.8-19.2l38.4-38.4 153.6-153.6 121.6 121.6-64 51.2z m147.2-153.6c-6.4 12.8-12.8 25.6-19.2 32l-19.2 19.2L576 326.4l19.2-19.2 19.2-19.2c32-19.2 76.8-19.2 102.4 6.4 25.6 38.4 32 70.4 19.2 102.4z"
                      p-id="4327"
                    ></path>
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <svg
                    @click="getDelIndex(scope.row)"
                    t="1648024716931"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4471"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M844.8 326.4c-19.2 0-38.4 19.2-38.4 38.4v550.4c0 19.2-19.2 38.4-38.4 38.4H256c-19.2 0-38.4-19.2-38.4-38.4V364.8c0-19.2-12.8-38.4-38.4-38.4-19.2 0-38.4 19.2-38.4 38.4v550.4C147.2 972.8 192 1024 256 1024h512c64 0 115.2-51.2 115.2-115.2v-544c0-19.2-19.2-38.4-38.4-38.4zM435.2 761.6V364.8c0-19.2-12.8-38.4-38.4-38.4-19.2 0-38.4 19.2-38.4 38.4V768c0 19.2 12.8 38.4 38.4 38.4 25.6-6.4 38.4-19.2 38.4-44.8z m224 0V364.8c0-19.2-19.2-38.4-38.4-38.4s-38.4 19.2-38.4 38.4V768c0 19.2 19.2 38.4 38.4 38.4 19.2-6.4 38.4-19.2 38.4-44.8z m326.4-582.4H806.4v-70.4C806.4 51.2 755.2 0 697.6 0H326.4c-64 0-108.8 44.8-108.8 108.8v76.8H38.4C19.2 179.2 0 198.4 0 217.6s19.2 32 38.4 32h947.2c19.2 0 38.4-12.8 38.4-32s-19.2-38.4-38.4-38.4z m-256 0H288v-70.4c0-19.2 19.2-38.4 38.4-38.4h371.2c19.2 0 32 12.8 32 38.4v70.4z m0 0"
                      p-id="4472"
                    ></path>
                  </svg>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p
          v-if="tableData.length === 0"
          style="text-align:center;margin-top:10px;color:#666;font-size:16px"
        >
          暂无数据
        </p>
      </div>
      <div
        class="delete-box"
        @click="openDelWindow"
        v-if="multipleSelection.length > 1"
      >
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
      <div class="pagination">
        <Paging :total="total" :page.sync="page" :limit="9"></Paging>
      </div>
      <modify-strain
        v-if="dialogFormVisible"
        :obj="tableData[index]"
        :title="title"
        @closeModify="closeModify"
      ></modify-strain>
    </div>
    <div class="tip-box cover_height_long">
      <el-dialog title="覆盖提示" :visible.sync="dialogCover">
        <div class="dialog-content">
          <div class="content-left">
            <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
          </div>
          <div class="content-right">
            <h2>以下文件重复，是否覆盖</h2>
            <div>
              <p v-for="item in coverMes" :key="item.index">{{ item }}</p>
            </div>
          </div>
        </div>
        <div class="caozuo">
          <button @click="confirmCover">
            确定
          </button>
          <button @click="cancelCover">取消</button>
        </div>
      </el-dialog>
    </div>
    <div class="tip-box">
      <el-dialog title="删除" :visible.sync="dialogVisible">
        <div class="dialog-content">
          <div class="content-left">
            <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
          </div>
          <div class="content-right">
            <h2>确认删除毒株？</h2>
          </div>
        </div>
        <div class="caozuo">
          <button @click="removeSingle">
            确定
          </button>
          <button
            @click="
              dialogVisible = false
              delrow = null
            "
          >
            取消
          </button>
        </div>
      </el-dialog>
    </div>
    <div class="tip-box">
      <el-dialog title="删除" :visible.sync="dialogVisible1">
        <div class="dialog-content">
          <div class="content-left">
            <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
          </div>
          <div class="content-right">
            <h2>确认删除毒株？</h2>
          </div>
        </div>
        <div class="caozuo">
          <button @click="removeMultiple">
            确定
          </button>
          <button @click="dialogVisible1 = false">取消</button>
        </div>
      </el-dialog>
    </div>
    <div class="tip-box fail_height_long">
      <el-dialog title="失败提示" :visible.sync="dialogFail" @close="closeDialogFail()">
        <div class="dialog-fail-content">
          <el-table
            :data="failList"
            style="width: 100%"
            class="fail-table"
            max-height="250"
          >
            <el-table-column
              prop="number"
              label="行号"
              v-if="isExcel"
              width="60px"
            >
            </el-table-column>
            <el-table-column prop="name" label="名称" width="300px">
              <template slot-scope="{ row }">
                <span>{{ row.name || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reason"
              label="错误原因"
              style="color:#f56c6c"
            >
              <template slot-scope="{ row }">
                <span style="color: #f56c6c">{{ row.reason || '-' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <p style="line-height:14px;margin-top:20px">
            共{{ failList.length }}条
          </p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { Message } from 'element-ui'
import Paging from '@/components/paging.vue'
import ModifyStrain from '@/components/backstage/modifyStrain.vue'
export default {
  name: 'Strain',
  components: {
    Paging,
    ModifyStrain
  },
  data () {
    return {
      formInline: {
        user: '',
        code: '',
        startDate: '',
        undateDate: ''
      },
      tableData: [],
      multipleSelection: [],
      newBuild: false, // 新建
      dialogVisible: false,
      dialogVisible1: false,
      total: 0,
      page: 1,
      fileList: [],
      FileRawAll: [],
      dialogFormVisible: false,
      index: -1,
      title: '',
      delrow: [],
      importSequenceList: [],
      updateSequenceList: [],
      repeatList: [],
      successList: {},
      dialogCover: false,
      coverMes: [],
      objLength: 0,
      fullscreenLoading: false,
      updataIndex: 0,
      excelFile: null,
      dialogFail: false,
      failList: [],
      isExcel: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getDelIndex (row) {
      this.delrow = row
      this.dialogVisible = true
    },
    getData () {
      let { startDate, undateDate } = this.formInline
      let startCreateTime = ''
      let endCreateTime = ''
      let startUpdateTime = ''
      let endUpdateTime = ''
      if (startDate && startDate.length === 2) {
        startCreateTime = startDate[0]
        startCreateTime = startCreateTime.slice(1)
        startCreateTime = startCreateTime.slice(0, startCreateTime.length - 1)
        endCreateTime = startDate[1]
        endCreateTime = endCreateTime.slice(1)
        endCreateTime = endCreateTime.slice(0, endCreateTime.length - 1)
      } else {
        startCreateTime = ''
        endCreateTime = ''
      }
      if (undateDate && undateDate.length === 2) {
        startUpdateTime = undateDate[0]
        startUpdateTime = startUpdateTime.slice(1)
        startUpdateTime = startUpdateTime.slice(0, startUpdateTime.length - 1)
        endUpdateTime = undateDate[1]
        endUpdateTime = endUpdateTime.slice(1)
        endUpdateTime = endUpdateTime.slice(0, endUpdateTime.length - 1)
      } else {
        startUpdateTime = ''
        endUpdateTime = ''
      }
      api
        .getAnnotationFuzzyQuery(
          this.formInline.user,
          this.formInline.code,
          startCreateTime,
          endCreateTime,
          startUpdateTime,
          endUpdateTime,
          this.page
        )
        .then(res => {
          if (res.data.code === 200) {
            this.tableData = res.data.data.records
            this.tableData.forEach(item => {
              item.createTime = item.createTime.slice(0, 10)
              item.updateTime = item.updateTime.slice(0, 10)
            })
            this.total = res.data.data.total
            // this.page = res.data.data.current
          } else {
            Message.error(`${res.data.msg}`)
          }
        })
    },
    // 重置
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.getData()
    },
    // 勾选框
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 导入序列
    fileHandleMoreChange (file, fileArr) {
      this.fileList.push(file)
    },
    // 上传序列
    ListUpdata (list) {
      this.importSequenceList = list
      if (this.importSequenceList.length !== 0) {
        let fileNameArr = []
        this.FileRawAll = []
        this.importSequenceList.forEach(item => {
          let obj = {}
          obj.fileName = item['name'].substring(0, item['name'].indexOf('.'))
          obj.fullName = item['name']
          fileNameArr.push(obj)
          this.FileRawAll.push(item.raw)
        })
        api.importSequence(fileNameArr).then(res => {
          if (res.data.code === 200) {
            if (res.data.data.fail.length !== 0) {
              // 有失败，通知后结束
              this.failList = res.data.data.fail
              this.dialogFail = true
            } else {
            // 成功与重复都无，清空数据
              if (
                res.data.data.success.length === 0 &&
              JSON.stringify(res.data.data.repeat) === '{}'
              ) {
                this.fileList = []
                return
              }
              if (
                JSON.stringify(res.data.data.success) !== '{}' &&
              JSON.stringify(res.data.data.repeat) !== '{}'
              ) {
              // 有成功，有重复
              // 成功
                this.successList = res.data.data.success
                let updataList = []
                for (let i in res.data.data.success) {
                  this.importSequenceList.forEach(ele => {
                    if (i === ele.name) {
                      updataList.push(ele)
                    }
                  })
                }
                this.updateSequenceList = updataList
                // 重复
                this.repeatList = res.data.data.repeat
                let mes = []
                for (let i in res.data.data.repeat) {
                  mes.push(i)
                }
                this.coverMes = mes
                // 是否覆盖
                setTimeout(() => {
                  this.dialogCover = true
                })
              } else if (
                JSON.stringify(res.data.data.success) !== '{}' &&
              JSON.stringify(res.data.data.repeat) === '{}'
              ) {
              // 有成功，无重复
                this.successList = res.data.data.success
                let updataList = []
                for (let i in res.data.data.success) {
                  this.importSequenceList.forEach(ele => {
                    if (i === ele.name) {
                      updataList.push(ele)
                    }
                  })
                }
                this.updateSequenceList = updataList
                this.classifyAndUploading()
              } else if (
                JSON.stringify(res.data.data.success) === '{}' &&
              JSON.stringify(res.data.data.repeat) !== '{}'
              ) {
              // 无成功，有重复
                this.updateSequenceList = []
                this.repeatList = res.data.data.repeat
                let mes = []
                for (let i in res.data.data.repeat) {
                  mes.push(i)
                }
                this.coverMes = mes
                // 是否覆盖
                setTimeout(() => {
                  this.dialogCover = true
                })
              } else {
              // 无成功，无重复
                this.fileList = []
                this.updateSequenceList = []
              }
            }
          } else {
            Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    // 确认覆盖
    confirmCover () {
      // 调用删除接口，将信息拉进成功数据
      let list = []
      for (let i in this.repeatList) {
        list.push(this.repeatList[i].fileId)
        this.importSequenceList.forEach(ele => {
          if (i === ele.name) {
            this.updateSequenceList.push(ele)
          }
        })
        this.successList[i] = this.repeatList[i].id
      }
      this.deleteAnnotationFileById(list)
      this.dialogCover = false
    },
    // 取消覆盖
    cancelCover () {
      this.classifyAndUploading()
      this.dialogCover = false
      if (this.updateSequenceList.length === 0) {
        this.fileList = []
      }
    },
    // 批量删除文件
    deleteAnnotationFileById (list) {
      api.deleteAnnotationFileById(list).then(res => {
        if (res.data.code === 200) {
          this.classifyAndUploading()
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 文件上传
    classifyAndUploading () {
      let FileRaw = new FormData()
      this.updateSequenceList.forEach(item => {
        FileRaw.append('files', item.raw)
      })
      if (this.updateSequenceList.length > 0) {
        this.fullscreenLoading = true
        api
          .classifyAndUploading('1647247202469', FileRaw)
          .then(res => {
            if (res.data.code === 200) {
              var obj = {}
              res.data.data.forEach(ele => {
                if (obj[this.successList[ele.fileName]] === undefined) {
                  obj[this.successList[ele.fileName]] = [ele]
                } else {
                  obj[this.successList[ele.fileName]].push(ele)
                }
              })
              this.objLength = Object.getOwnPropertyNames(obj).length
              this.updataIndex = 0
              for (let i in obj) {
                this.updataAnnotationFile(i, obj[i])
              }
            } else {
              Message.error(`${res.data.msg}`)
              this.fullscreenLoading = false
              this.fileList = []
              this.getData()
            }
          })
          .catch(rep => {
            Message.error(`${rep}`)
            this.fullscreenLoading = false
            this.fileList = []
          })
      } else {
        this.fullscreenLoading = false
        this.fileList = []
      }
    },
    // 更新毒株信息
    updataAnnotationFile (id, detail) {
      if (this.updataIndex < this.objLength) {
        api.updataAnnotationFile(id, detail).then(res => {
          if (res.data.code === 200) {
          } else {
            Message.error(`${res.data.msg}`)
          }
          this.updataIndex++
          if (this.updataIndex === this.objLength) {
            Message.success(`${res.data.msg}`)
            this.fullscreenLoading = false
            this.getData()
            this.fileList = []
          }
        })
      }
    },
    // 删除单个毒株的弹窗
    removeSingle () {
      api.deleteByStrain(this.delrow.annotationId).then(res => {
        if (res.data.code === 200) {
          this.getData()
          Message.success(`${res.data.msg}`)
          this.delrow = null
        } else {
          Message.error(`${res.data.msg}`)
        }
        this.dialogVisible = false
      })
    },
    // 勾选多个打开删除弹窗
    openDelWindow () {
      this.dialogVisible1 = true
    },
    // 删除多个毒株的弹窗
    removeMultiple () {
      let list = []
      this.multipleSelection.forEach(item => {
        list.push(item.annotationId)
      })
      this.recursiveDel(list)
    },
    // 批量删除毒株
    recursiveDel (list) {
      api.deleteByStrainList(list).then(res => {
        if (res.data.code === 200) {
          Message.success(`${res.data.msg}`)
        } else {
          Message.error(`${res.data.msg}`)
        }
        this.getData()
        this.dialogVisible1 = false
      })
    },
    // 下载模板
    downloadWebData () {
      let element = document.createElement('a')
      element.setAttribute('href', '/base/downloadWebData?fullpath=plugins/alage/starinTemplate.xlsx')
      element.setAttribute('download', 'starinTemplate.xlsx')
      element.style.display = 'none'
      element.click()
      // window.location.href =
      //   '/base/downloadWebData?fullpath=plugins/alage/starinTemplate.xlsx'
    },
    // 获取上传的文件
    getExcelFile (file) {
      this.excelFile = file
    },
    // 表头检测
    getExcelFileContent () {
      if (this.excelFile) {
        let FileRaw = new FormData()
        FileRaw.append('file', this.excelFile.raw)
        api.getExcelFileContent(FileRaw, 'strain').then(res => {
          if (res.data.code === 200) {
            if (res.data.data.length === 0) {
              Message.error('表格无数据')
            } else {
              this.importTemplateByStrain(res.data.data)
            }
          } else {
            Message.error(`${res.data.msg}`)
          }
          this.excelFile = null
        })
      }
    },
    // 导入数据(excel)
    importTemplateByStrain (list) {
      api.importTemplateByStrain(list).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.length !== 0) {
            // 打开弹窗
            this.failList = res.data.data
            this.dialogFail = true
            this.isExcel = true
          } else {
            Message.success(`${res.data.msg}`)
            this.getData()
          }
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 弹窗
    openModify (val) {
      if (val === 'new') {
        this.index = -1
        this.title = 'New strain'
        this.dialogFormVisible = true
      } else {
        this.index = val
        this.title = 'Modified strain'
        this.dialogFormVisible = true
      }
    },
    closeModify () {
      this.dialogFormVisible = false
      this.getData()
    },
    // 关闭失败窗口
    closeDialogFail () {
      this.excelFile = null
      this.isExcel = false
      this.failList = []
      this.fileList = []
    }
  },
  watch: {
    page (newal, oldal) {
      // 请求数据
      this.page = newal
      this.getData()
    },
    fileList: 'ListUpdata',
    excelFile: 'getExcelFileContent'
  }
}
</script>

<style lang="scss" scoped>
.strain {
  padding: 11px;
  .header-breadcrumb {
    margin-bottom: 14px;
    width: 100%;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    .header-utils {
      height: 100%;
      position: absolute;
      top: 0;
      right: 20px;
      width: 80px;
      display: flex;
      align-items: center;
      .add {
        margin-right: 30px;
        cursor: pointer;
      }
      .dropdown {
        box-sizing: border-box;
        margin-right: 15px;
        padding-top: 5px;
        display: flex;
        align-items: center;
        >>> .el-dropdown-menu {
          .el-dropdown-menu__item {
            width: 300px;
          }
        }
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 33%;
        left: 29px;
        height: 15px;
        width: 1px;
        background-color: #999;
      }
    }
  }
  .middle-box {
    background-color: #fff;
    width: 100%;
    // height: 940px;
    // height: 880px;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    .search-box {
      text-align: right;
      margin-bottom: 40px;
      position: relative;
      .el-form-item {
        margin-bottom: 0;
        >>> .el-form-item__label {
          color: #333;
          line-height: 30px;
        }
        >>> .el-form-item__content {
          height: 30px;
          line-height: 30px;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            // width: 350px;
            .el-input__icon,
            .el-range-separator {
              height: auto;
            }
          }
          .user-input {
            .el-input__inner {
              width: 177px;
            }
          }
          .el-button {
            height: 30px;
            font-size: 14px;
            box-sizing: border-box;
            padding: 2px 18px;
            border-radius: 4px;
          }
          .el-button--primary {
            background: $theme_color;
            border-color: $theme_color;
          }
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-range-editor.is-active,
          .el-range-editor.is-active:hover {
            border-color: $theme_color;
          }
          .el-button--default {
            padding-left: 0;
            padding-right: 0;
            color: #333333;
            border: none;
            background-color: #fff;
            &:hover {
              color: $theme_color;
            }
          }
        }
      }
      &::after {
        display: block;
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        height: 1px;
        width: 100%;
        background-color: #dddddd;
      }
    }
    .table-box {
      .table {
        >>> .el-table__fixed-right,
        >>> .el-table__fixed {
          height: calc(100% - 17px) !important;
        }
      }
      .el-table::before {
        height: 0;
      }
      .el-table >>> .el-table__empty-block {
        display: none;
      }
      .el-table >>> .el-table__body {
        border-collapse: separate;
        border-spacing: 0 10px;
      }
      .el-table >>> thead {
        color: #333;
        margin-bottom: 10px;
        th {
          line-height: 30px;
        }
      }
      .el-table >>> .el-table__cell {
        padding: 12px 0;
      }
      .el-table >>> td.el-table__cell,
      .el-table >>> th.el-table__cell.is-leaf {
        // border-bottom: none;
        border-top: 1px solid rgba(40, 40, 40, 0.14);
        border-bottom: 1px solid rgba(40, 40, 40, 0.14);
      }
      .el-table >>> .el-table__row td:first-child,
      .el-table >>> tr th:first-child {
        border-left: 1px solid rgba(40, 40, 40, 0.14);
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      .el-table >>> .el-table__row td:last-child,
      .el-table >>> tr th:last-child {
        border-right: 1px solid rgba(40, 40, 40, 0.14);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      .el-table >>> th.el-table__cell > .cell {
        padding-left: 13px;
        padding-right: 13px;
      }
      .el-input >>> .el-input__inner {
        border-color: #fff;
        padding: 0;
        height: 30px;
        line-height: 30px;
      }
      .el-input.is-active >>> .el-input__inner,
      >>> .el-input__inner:focus {
        border-color: $theme_color;
      }
      >>> .el-checkbox__input.is-checked .el-checkbox__inner,
      >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: $theme_color;
        border-color: $theme_color;
      }
      >>> .el-checkbox__inner:hover,
      >>> .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: $theme_color;
      }
      .el-table >>> .el-table__row {
        // box-shadow: 0px 0px 4px 0px rgba(40, 40, 40, 0.14);
        border: 1px solid rgb(40, 40, 40);
        border-radius: 4px;
      }
      .disappear {
        display: none;
        .icon {
          cursor: pointer;
          margin-right: 21px;
          path {
            fill: #666;
          }
          &:hover {
            path {
              fill: $theme_color;
            }
          }
          &:last-child {
            margin-right: 0;
            &:hover {
              path {
                fill: #f56c6c;
              }
            }
          }
        }
      }
      >>> .el-table__body .el-table__row.hover-row td .appear {
        display: block;
      }

      // >>> .el-table__fixed-right {
      //   // background: white !important;
      //   // box-shadow: none !important;
      // }
      // .el-table >>> tr th:last-child {
      //   position: relative;
      //   overflow: auto;
      //   &::after {
      //     display: block;
      //     content: '';
      //     position: absolute;
      //     left: 8px;
      //     top: 0;
      //     height: 100%;
      //     width: 2px;
      //     z-index: 100;
      //     box-shadow: -5px 0 6px 0 rgba(40, 40, 40, 0.28);
      //     // border-left: 1px solid rgba(40, 40, 40, 0.28);
      //   }
      // }
    }

    .marginTop {
      margin-top: 10px;
    }
    .pagination {
      text-align: center;
      margin-top: vw(21);
    }

    .delete-box {
      position: fixed;
      top: 85%;
      left: 50%;
      transform: translateX(-50%);
      width: 193px;
      height: 46px;
      background: #f1f2f4;
      box-shadow: 0px 0px 16px 0px rgba(40, 40, 40, 0.2);
      border-radius: 23px;
      cursor: pointer;
      font-size: 14px;
      color: #f56c6c;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon-delete {
        font-size: 16px;
        margin-right: 18px;
      }
    }
  }
  .tip-box {
    >>> .el-dialog {
      width: 482px !important;
      margin-top: 30vh !important;
      box-shadow: none !important;
    }
    >>> .el-dialog .el-dialog__header {
      font-weight: 550;
      line-height: 50px;
      color: #333;
    }
    >>> .el-dialog .el-dialog__body {
      line-height: 20px;
      padding: 0 20px 10px;
    }
    >>> .el-dialog .dialog-content {
      display: flex;
      width: 100%;
    }
    >>> .el-dialog .dialog-fail-content {
      .fail-table {
        .el-table__cell {
          padding: 8px 0;
        }
        th {
          color: #333;
        }
      }
    }
    >>> .el-dialog .caozuo {
      margin-top: 10px;
      width: 100%;
      text-align: right;
    }
    >>> .el-dialog .caozuo button {
      width: 80px;
      height: 34px;
      border-radius: 2px;
      border: 0;
      outline: none;
      cursor: pointer;
    }
    >>> .el-dialog__header {
      padding: 0 20px;
    }
    >>> .el-dialog .caozuo button:first-child {
      background: $theme_color;
      color: #fff;
      border: 1px solid $theme_color;
      margin-right: 10px;
    }
    >>> .el-dialog .caozuo button:last-child {
      background: #fff;
      color: #999999;
      border: 1px solid #999;
    }
    >>> .el-dialog .dialog-content .content-right {
      width: 75%;
    }
    >>> .el-dialog .dialog-content .content-left img {
      padding: 5px 20px;
    }
    >>> .el-dialog .dialog-content .content-right h2 {
      line-height: 30px;
      font-size: 18px;
      font-weight: 500;
      color: #666;
    }
    >>> .el-dialog .dialog-content .content-right div {
      font-size: 14px;
      line-height: 30px;
      font-weight: 500;
      height: 100px;
      overflow: auto;
      color: #999;
    }
    >>> .el-dialog__headerbtn:focus .el-dialog__close,
    >>> .el-dialog__headerbtn:hover .el-dialog__close {
      color: $theme_color;
    }
  }
  .cover_height_long{
    >>> .el-dialog {
      width: 550px !important;
    }
    >>> .el-dialog .dialog-content .content-right div {
      height: 200px;
    }
    >>> .el-dialog .dialog-content .content-right {
      width: 80%;
    }
  }
  .fail_height_long{
    >>> .el-dialog {
      width: 640px !important;
    }
  }
}

.el-dropdown-menu__item {
  padding: 5px 10px;
  color: #666;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fff;
  color: #666;
}
.excel {
  &:hover {
    color: $theme_color;
  }
}
.tip-confirm-btn {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/backstage/strain/strain.vue